<template>
  <filial-settings-view
    title="Заказы"
    :keys="settingKeys"
    hide-group-titles
  />
</template>

<script>
  import FilialSettingsView from '@/components/ui/crud/fields/filials/FilialSettingsView.vue'
  import SettingKey from '@/models/enums/SettingKey'

  export default {
    name: 'OrdersSettings',
    components: { FilialSettingsView },
    data () {
      return {
        settingKeys: [
          SettingKey.PreorderAutoPrepareEnabled,
          SettingKey.NewOrderSound,
          SettingKey.PreorderAutoPrepareSound,
        ],
      }
    },
  }
</script>
